import { LAYOUT } from './constants'

const HEADER_BACKGROUND_EXTRA_PX = 8

export function PageHeader({ isEven, bleedPx = 0 }: { isEven: boolean; bleedPx?: number }) {
  const curveBottom = -bleedPx - HEADER_BACKGROUND_EXTRA_PX - 1

  return (
    <div
      className="relative w-full"
      style={{
        height: LAYOUT.header.totalHeight,
        overflow: 'visible',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          height: LAYOUT.header.totalHeight + bleedPx + HEADER_BACKGROUND_EXTRA_PX,
          background: '#FEF1CB',
        }}
      />
      {/* White curved overlay — curve side inset to A4 boundary, straight side extends to edge */}
      <div
        style={{
          position: 'absolute',
          bottom: curveBottom,
          left: isEven ? 0 : bleedPx,
          right: isEven ? bleedPx : 0,
          height: LAYOUT.header.curveHeight + 1,
          background: '#ffffff',
          ...(isEven
            ? { borderTopRightRadius: LAYOUT.header.curveHeight }
            : { borderTopLeftRadius: LAYOUT.header.curveHeight }),
        }}
      />
    </div>
  )
}
